import {Component, Input, OnInit} from '@angular/core';
import {TimeSlot} from '../../../../store/entities';
import {isCurrentSlot} from '../../../../store';

@Component({
  selector: 'mwo-setlist-planning-item',
  templateUrl: './setlist-planning-item.component.html',
  styleUrls: ['./setlist-planning-item.component.scss']
})

export class SetlistPlanningItemComponent implements OnInit {
  @Input() animateEqualizer: boolean;
  @Input() timeSlot: TimeSlot = {
    startTime: [0, 0],
    endTime: [0, 0]
  };
  @Input() color: string;
  @Input() fromModifierPage = false;
  isCurrentSlot = false;

  constructor() {
  }

  ngOnInit() {
    this.isCurrentSlot = isCurrentSlot(this.timeSlot);
  }
}
